/** Small text helpers shared by screens. Kept here so a sentence reads the same everywhere. */

/** `['a']` → `a` · `['a','b']` → `a and b` · `['a','b','c']` → `a, b and c`. */
export function joinAnd(items: readonly string[]): string {
  if (items.length <= 1) return items[0] ?? '';
  return `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`;
}

/** "1 maker", "3 makers"; pass `plural` for a noun that does not take a plain -s ("cities"). */
export function count(n: number, noun: string, plural = `${noun}s`): string {
  return `${n} ${n === 1 ? noun : plural}`;
}
